import type { ReactNode, Ref } from 'react'
import { Link } from 'react-router'
import { ChevronRightIcon } from './icons'

interface DisclosureRowProps {
  label: string
  /** 행이 지금 들고 있는 값. 없으면 라벨만 선다. */
  value?: ReactNode
  onClick?: () => void
  disabled?: boolean
  to?: string
  /** 덮는 층을 닫은 뒤 포커스를 이 행으로 되돌리는 자리가 쓴다. */
  ref?: Ref<HTMLButtonElement>
}

/**
 * 다른 자리를 여는 행.
 *
 * 오른쪽 끝의 쉐브론이 말하는 것은 하나다. 누르면 무엇인가 열린다. 열리는 것이 화면인지
 * 시트인지는 가르지 않는다. 기호를 둘로 나누면 사용자가 그 차이를 배워야 하는데 배워서 얻는
 * 것이 없고, 좁은 폭에서 시트로 열리고 넓은 폭에서 대화로 서는 항목은 폭에 따라 기호가 바뀐다.
 *
 * 행을 상자로 감싸지 않는다. 행마다 테두리가 서면 목록이 버튼 더미가 되고 무엇이 먼저 읽힐지
 * 사라진다. 아래에 두는 선은 면을 가르는 장식이라 border를 쓴다.
 *
 * 행 전체가 타깃이고 누른 자리를 알리는 면도 행 전체를 채운다. 라벨에만 얹으면 어디까지가
 * 타깃인지 어긋난다.
 */
export function DisclosureRow({ label, value, onClick, disabled, to, ref }: DisclosureRowProps) {
  const shape =
    'pressable border-border/60 flex min-h-12 w-full items-center justify-between gap-4 border-b px-1 text-left disabled:opacity-60'

  const body = (
    <>
      <span className="text-ink">{label}</span>
      <span className="text-ink-muted flex shrink-0 items-center gap-1">
        {value}
        <ChevronRightIcon />
      </span>
    </>
  )

  if (to) {
    return (
      <Link to={to} className={shape}>
        {body}
      </Link>
    )
  }

  return (
    <button ref={ref} type="button" onClick={onClick} disabled={disabled} className={shape}>
      {body}
    </button>
  )
}
